import { registerEventHandler } from '@/overlord/events';

export default function () {
  registerEventHandler('reload-site-config', ({ store }) => {
    console.debug('Reloading site config...');
    store.dispatch('LOAD_SITE_CONFIG', store.getters.siteId);
  });
  registerEventHandler('staff-notification', ({ store, payload }) => {
    console.debug('Notification received...', { payload });
    store.dispatch('staffNotification/PROCESS_NEW_STAFF_NOTIFICATION', payload);
  });
}
